<template>
  <div class="data-list-container">
    <!-- <pre>
    school {{ schoolAdmin }}
    create {{ createModuleAction }}
    edit {{ editModuleAction }}
    view {{ viewModuleAction }}
    delete {{ deleteModuleAction }}
     </pre
    > -->
    <!-- {{addSideBar}} -->
    <vs-popup
      class="popup"
      title="Column Rearrangement"
      :active.sync="columnRearrangementModal"
    >
      <RearrangeManagement
        @closeRearrangementModal="closeRearrangementModal"
        v-if="columnRearrangementModal"
        moduleProps="Staff"
        :table_name="table_name"
        is_dynamic = "true"
      ></RearrangeManagement>
    </vs-popup>
    <StaffSummary :module_id="38" v-model="maximizeCard" />
    <create-user
      v-show="addSideBar"
      :staticFields="staticFields"
      :isSidebarActive="addSideBar"
      :custom_fields_required="custom_fields_required"
      :dynamicFormObject="dynamicFormObject"
      :countryList="countryList"
      @closeSidebar="handlcreateSidebar"
    ></create-user>
    <!-- filter Side Bar -->
    <filter-sidebar
      :isSidebarActive="filterSidebarBoolean"
      :fieldtabledata="fieldtabledata"
      :filterconditiondata="filterconditiondata"
      platformmodulename="Staff"
      @closedsidebarevent="filterSidebarEvent"
      :name="table_name"
    ></filter-sidebar>
    <!-- view SIdebar -->
    <vs-sidebar
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="get_leads_sidebar_view"
    >
      <view-user-sidebar
        :isSidebarActive="get_leads_sidebar_view"
        :get_leads_sidebar_data="get_leads_sidebar_data"
        :timelineData="timelineData"
        @closeSidebar="handleViewSidebar"
      ></view-user-sidebar>
    </vs-sidebar>

    <vx-card title="" class="mb-4">
      <div
        v-if="isRowSelected"
        style="font-size: 13.8px; padding: 7px; float: right"
      >
        <vs-button
          v-if="checkEditPermission()"
          class="custom-btn1"
          type="border"
          style="border-radius: 5px 0px 0px 5px"
          :disabled="!isRowSelected"
          @click="handleExport"
          >Export</vs-button
        >
        <vs-button
          class="custom-btn1"
          type="border"
          :disabled="!isRowSelected"
          @click="(bulkEmailModal = !bulkEmailModal), bulkMailAdd()"
          >Bulk Email</vs-button
        >
        <!-- <vs-button class="custom-btn1" type="border" :disabled="!isRowSelected"
          >Assign</vs-button
        > -->
        <vs-button
          class="custom-btn1"
          type="border"
          :disabled="!isRowSelected"
          @click="bulkupdateModal = !bulkupdateModal"
          >Update Field</vs-button
        >
        <vs-button
          v-if="checkDeletePermission()"
          class="custom-btn1"
          type="border"
          @click="handleBulkDelete"
          :disabled="!isRowSelected"
          >Delete</vs-button
        >
        <!-- <vs-dropdown
          vs-custom-content
          vs-trigger-click
          class="cursor-pointer"
          :disabled="!isRowSelected"
        >
          <vs-button
            class="custom-btn1 btnx"
            type="border"
            :disabled="!isRowSelected"
          >
            More
            <i
              class="material-icons"
              style="font-size: 12px; vertical-align: middle; font-weight: 600"
              >keyboard_arrow_down</i
            >
          </vs-button>
          <vs-dropdown-menu>
            <vs-dropdown-item>option 1</vs-dropdown-item>
            <vs-dropdown-item>option 2</vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown> -->
        <!-- <vs-button
          class="custom-btn1"
          type="border"
          style="border-radius: 0px 5px 5px 0px"
          :disabled="!isRowSelected"
        >
          <i
            class="material-icons"
            style="font-size: 12px; vertical-align: middle; font-weight: 600"
            >sync</i
          >
        </vs-button> -->
      </div>

      <vs-row class="mt-2">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
        >
          <div class="md:w-1/2 w-full p-1">
            <vs-input
              placeholder="Search"
              class="w-full"
              v-model="search"
              @keyup="searchFun"
              style="width: 100%"
            />
          </div>
          <!--  <vs-select
            label="Select Filter"
            autocomplete
            class="selectExample w-full pl-2"
            v-model="select_filter_id"
            @change="getFilterByUser()"
          >
            <vs-select-item
              :key="user_filter.id"
              :value="user_filter"
              :text="user_filter.filter_name"
              v-for="user_filter in user_main_filter"
            />
          </vs-select> -->
          <div class="p-1" v-if="checkEditPermission()">
            <!-- <vs-tooltip color="primary" text="Filter" position="top">
              <vs-button
                class="btn-w-icon"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-filter"
                @click="filterSidebarBoolean = !filterSidebarBoolean"
              />
            </vs-tooltip> -->
          </div>

          <div class="p-1">
            <vs-tooltip color="primary" text="Filter View" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="overallSearch"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <rect width="18" height="18" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14ZM11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.1465 16.3536L13.1465 14.3536L13.8536 13.6465L15.8536 15.6465L15.1465 16.3536Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H15C16.3807 0.5 17.5 1.61929 17.5 3V14.5H16.5V3C16.5 2.17157 15.8284 1.5 15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V15C1.5 15.8284 2.17157 16.5 3 16.5H13.5V17.5H3C1.61929 17.5 0.5 16.3807 0.5 15V3Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.5 5.5H1.5V4.5H16.5V5.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 8.5H1.5V7.5H7.5V8.5ZM16.5 8.5H15V7.5H16.5V8.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.5 11.5H1.5V10.5H6.5V11.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 14.5H1.5V13.5H7.5V14.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.5 16.5V5H5.5V16.5H4.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>

          <div class="p-1" v-if="checkEditPermission()">
            <vs-tooltip color="primary" text="Rearrange Column" position="top">
              <vs-button
                @click="columnRearrangement"
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                icon="published_with_changes"
              >
              </vs-button>
            </vs-tooltip>
          </div>

          <div class="p-1" v-if="checkEditPermission()">
            <vs-tooltip color="primary" text="Import CSV/ XLS" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="excelModal()"
              >
                <svg
                  style="width: 24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 7H7C5.89543 7 5 7.89543 5 9V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V9C21 7.89543 20.1046 7 19 7ZM7 5C4.79086 5 3 6.79086 3 9V21C3 23.2091 4.79086 25 7 25H19C21.2091 25 23 23.2091 23 21V9C23 6.79086 21.2091 5 19 5H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    d="M15.294 19.8L12.928 16.398L10.604 19.8H8L11.626 14.816L8.182 10H10.758L13.012 13.178L15.224 10H17.674L14.258 14.732L17.912 19.8H15.294Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.75 15V13H39C42.3137 13 45 15.6863 45 19V37C45 40.3137 42.3137 43 39 43H22C18.6863 43 16 40.3137 16 37V24.5H18V37C18 39.2091 19.7909 41 22 41H39C41.2091 41 43 39.2091 43 37V19C43 16.7909 41.2091 15 39 15H21.75Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 28V32C10 34.2091 11.7909 36 14 36H24V38H14C10.6863 38 8 35.3137 8 32V28H10Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.36396 28.8284L4.41421 33.7782L3 32.364L9.36396 26L15.7279 32.364L14.3137 33.7782L9.36396 28.8284Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 21.5H26V19.5H38.5V21.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 27.5H26V25.5H38.5V27.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 33.5H26V31.5H38.5V33.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>

          <div class="p-1">
            <vs-tooltip color="primary" text="Export Template" position="top">
              <vs-button
                @click="exportApi"
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
              >
                <svg
                  style="width: 24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 7H7C5.89543 7 5 7.89543 5 9V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V9C21 7.89543 20.1046 7 19 7ZM7 5C4.79086 5 3 6.79086 3 9V21C3 23.2091 4.79086 25 7 25H19C21.2091 25 23 23.2091 23 21V9C23 6.79086 21.2091 5 19 5H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    d="M15.294 19.8L12.928 16.398L10.604 19.8H8L11.626 14.816L8.182 10H10.758L13.012 13.178L15.224 10H17.674L14.258 14.732L17.912 19.8H15.294Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.75 15V13H39C42.3137 13 45 15.6863 45 19V37C45 40.3137 42.3137 43 39 43H18C14.6863 43 12 40.3137 12 37V24.5H14V37C14 39.2091 15.7909 41 18 41H39C41.2091 41 43 39.2091 43 37V19C43 16.7909 41.2091 15 39 15H21.75Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 26V30C8 32.2091 9.79086 34 12 34H22V36H12C8.68629 36 6 33.3137 6 30V26H8Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.8995 34.6569L16.9498 39.6066L18.364 41.0208L24.728 34.6569L18.364 28.2929L16.9498 29.7071L21.8995 34.6569Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 21.5H26V19.5H38.5V21.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 27.5H26V25.5H38.5V27.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 33.5H26V31.5H38.5V33.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>
        </vs-col>

        <vs-col vs-sm="12" vs-xs="12" vs-lg="4">
          <vs-row vs-type="flex" vs-justify="flex-end" vs-align="center">
            <!-- <vs-button
              class="btnx"
              style="margin-right: 1%"
              @click="columnRearrangement"
            >
              Resize Modal
            </vs-button> -->
            <!-- <vs-button
              v-if="this.checkCreatePermission()"
              class="btnx add-staff mr-2"
              @click="excelModal()"
              >Import CSV/XLS</vs-button
            > -->
            <vs-button
              v-if="checkCreatePermission"
              class="btnx add-staff"
              @click="addStaff"
              >Add Staff</vs-button
            >
            <!-- <vs-button color="primary" type="border" class="mr-2">Widget Panel</vs-button> -->
            <!-- <div class="dropdown-button-container">
              <vs-dropdown
                style="float: right; cursor: pointer"
                vs-custom-content
                vs-trigger-click
              >
                <vs-button
                  class="btn-w-icon"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-settings"
                />
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    class
                    :to="{
                      name: 'field-re-arrange',
                      params: { module_name: 'leads' },
                    }"
                    >Customize Columns</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    class
                    :to="{
                      name: 'custom-value-list-view',
                      params: { modelname: 'Staff' },
                    }"
                    >Create Custom Fields</vs-dropdown-item
                  >
                </vs-dropdown-menu>
              </vs-dropdown>
            </div> -->
          </vs-row>
        </vs-col>
      </vs-row>
      <!-- table -->
    </vx-card>
    <div v-if="bulkupdateModal == true">
      <UpdateModal
        :roleList="roleList"
        :countryList="countryList"
        :custom_fields_required="custom_fields"
        :displayListofdata="displayListofdata"
        @bulkupdatelist="bulkupdatelist"
      ></UpdateModal>
    </div>
    <vs-popup class="popup" title="Mail" :active.sync="bulkEmailModal">
      <BulkEmail
        :mail_id="mail_id"
        @mail_body="mail_body"
        v-if="bulkEmailModal"
      ></BulkEmail>
    </vs-popup>

    <div v-if="overallSearchHolder">
      <vs-card class="cstm_vx_card mb-4">
        <div slot="header" class="flex flex-wrap justify-between items-center">
          <h4>Filter View</h4>
          <vs-button @click="filterSidebarBoolean = !filterSidebarBoolean">Add Custom Filter</vs-button>
        </div>
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="sm:block block lg:flex"
          >
            <div class="lg:w-1/3 w-full p-1">
              <v-select
                placeholder="Select View"
                v-if="user_main_filter"
                class="w-full"
                label="filter_name"
                :options="user_main_filter"
                :reduce="item => item.id"
                :clearable="false"
                v-model="select_filter_id"
                @input="getFilterByUser()"
              >
              </v-select>
            </div>
            <div class="lg:w-1/3 w-full p-1">
              <v-select
                placeholder="Role Type"
                class="w-full"
                :options="roleList"
                v-model="searchByRoleType"
                label="role_name"
                :reduce="option => option.user_role_id"
              >
              </v-select>
            </div>
            <div class="lg:w-2/3 w-full p-1">
              <v-select
                placeholder="Select tag to search"
                v-model="tagSelected"
                class="w-full"
                multiple
                label="name"
                taggable
                :create-option="
                  option => ({ id: option, label: option, name: option })
                "
                :options="tagModuleWise"
                :clearable="false"
                data-vv-name="tag_list"
                name="tag_list"
              >
              </v-select>
            </div>
            <div class="flex p-1">
              <vs-button
                class="mx-2 includeIcon includeIconOnly"
                @click="searchByfilter"
                >Go</vs-button
              >
              <vs-tooltip color="primary" text="Reset Filters" position="top">
                <vs-button
                  type="border"
                  icon-pack="feather"
                  @click="resetSearch"
                  icon="icon-refresh-cw"
                ></vs-button>
              </vs-tooltip>
            </div>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>

    <div>
      <!-- <pre>{{limitedTableList[0]}}</pre> -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="limitedTableList"
        rowSelection="multiple"
        suppressRowClickSelection="true"
        colResizeDefault="true"
        :style="{ minHeight: meta.limit * 48 + 75 + 'px' }"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        @cell-value-changed="onCellValueChanged"
        @row-selected="CellvalueSelectDeselect"
        @cell-clicked="cellSingleClicked"
        @columnVisible="handleColumnHideShow"
        @columnMoved="handleRearrangement"
        @columnResized="resizeChanges($event)"
        :enableRtl="$vs.rtl"
        @sortChanged="sortFun"
      ></ag-grid-vue>
      <div class="flex justify-between items-center mt-2">
        <!-- page limit select view -->
        <ItemsPerTableDropdown
          :tableName="table_name"
          @change="pageLimit => (pageLimitSet = pageLimit)"
        />
        <pagination
          :meta="meta"
          @page-change="handlePageChange"
          class="ml-auto"
        />
      </div>
    </div>

    <vs-popup class="popup" title="Excel Upload" :active.sync="excelPopUp">
      <excel-modal
        :custom_fields_required="custom_fields_required"
        v-if="excelPopUp"
        :module_id="2"
        @uploadSuccess="uploadSuccess"
      ></excel-modal>
    </vs-popup>
    <div v-if="showCourseListModal">
      <CoursesListAction :showCourseListModal="showCourseListModal" :user_id="user_id" @CoursePopupClose="CoursePopupClose" />
    </div>
    <div v-if="showStudentListModal">
      <StudentsListAction :showStudentListModal="showStudentListModal" :user_id="user_id" @StudentPopupClose="StudentPopupClose" />
    </div>
  </div>
</template>
<script>
import FullNameCell from './FullNameCell.vue'
import axios from 'axios'
import EmailAction from './EmailAction'
import StudentsListAction from './StudentsListAction'
import CoursesListAction from './CoursesListAction'
import RolesCell from './RolesCell.vue'
import CountryCell from './Countrycell.vue'
import PhoneImageCell from './PhoneImageCell'
import DynamicSelect from './DynamicSelect.vue'
import DynamicBoolean from './DynamicBoolean.vue'
import DynamicDate from './DynamicDate'
import CreatedAtCell from './CreatedAtCell'
import { fetchField } from '@/api/columnrearrange.js'
import { fetchCustomStaticFields } from '@/api/customfield'
import { Tag } from '@/mixins/tag/tag'
import BulkEmail from '../email/composeEmail.vue'
import TagShow from '../leads/TagShow'
import UpdateModal from '@/components/common/UpdateModal.vue'
import router from '@/router'
import Prism from 'vue-prism-component'
import StaffSummary from '../analytics/summeryLIst'
import CreateUser from './components/CreateUser.vue'
import ViewUserSidebar from './components/ViewUserSidebar.vue'
import ExcelModal from './components/ExcelModal.vue'
import {
  fetchUserBySearch,
  user_list,
  update_user,
  delete_users,
  getFilterList,
  bulkUpdateApi,
  bulkEmailApi,
  role_list
} from '@/api/user'
import { displayField, GetCountryList } from '@/api/common'
import { exportApiDownload } from '@/api/excelApi'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VxTimeline from '@/components/timeline/VxTimeline.vue'
import vSelect from 'vue-select'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from './CellRendererActions'
import ToggleActions from './ToggleActions'
import EditActions from './EditActions'
import DeleteActions from './DeleteActions'
import PreviewActions from './PreviewActions'

import StatusCell from './statuscell'
import { mapGetters, mapActions } from 'vuex'
import Pagination from '@/components/common/pagination'
import FilterSidebar from '@/components/common/filter-sidebar'
import { DynamicField } from '@/mixins/dynamic-field'
import { DynamicFilter } from '@/mixins/dynamic-filter'

import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'
import RearrangeManagement from '@/views/pages/customFieldRearrage/RearrangeManagement'
import { arrangeColumn } from '@/api/columnrearrange'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  components: {
    TagShow,
    UpdateModal,
    Prism,
    StatisticsCardLine,
    VxTimeline,
    vSelect,
    AgGridVue,
    CellRendererActions,
    ToggleActions,
    EditActions,
    DeleteActions,
    PreviewActions,
    StatusCell,
    Pagination,
    flatPickr,
    FilterSidebar,
    CreateUser,
    ViewUserSidebar,
    StaffSummary,
    BulkEmail,
    RearrangeManagement,
    ExcelModal,
    CreatedAtCell,
    DynamicDate,
    DynamicBoolean,
    DynamicSelect,
    CountryCell,
    RolesCell,
    EmailAction,
    StudentsListAction,
    CoursesListAction,
    FullNameCell,
    PhoneImageCell
  },
  mixins: [DynamicField, DynamicFilter, PermissionMiddleware, Tag],

  data () {
    return {
      table_name:'staff_list',
      user_id:null,
      search: '',
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      staticFields: [],
      displayList: null,
      excelPopUp: false,
      staticField: [],
      columnRearrangementModal: false,
      selected_lead_is: [],
      searchByRoleType: '',
      roleList: [],
      platform_module_id: 38,
      overallSearchHolder: false,
      user_ids: [],
      mail_id: [],
      bulkEmailModal: false,
      maximizeCard: true,
      displayListofdata: [],
      bulkupdateModal: false,
      first_name: '',
      email: '',
      phone: '',
      last_name: '',
      user_roles_id: '',
      address: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        platform_customer_countries_id: 1,
        zip: ''
      },
      countryList: [],
      options1: [],

      errorCount: 0,
      api_response_message_show: false,
      api_response_message: '',
      // End
      table_switch: false,
      addSideBar: false,
      viewSideBar: false,
      filterSidebar: false,
      // custom_fields: [],
      // custom_fields_required: [],

      //filter sidebar
      filterSidebarBoolean: false,
      firstData: [],

      select_filter_id: '',

      selected: [],
      /// filter work
      customFilterName: '',
      dynamicFormObject: {},

      filterList: [
        {
          FilterName: 'Assigned',
          FilterValue: 'Assigned'
        }
      ],
      /// filter
      //select checkbox
      select_All: false,
      //
      // pagination
      //
      // pagelimit
      pageLimitOPtion: [
        {
          name: 5,
          value: 5
        },
        {
          name: 10,
          value: 10
        },
        {
          name: 20,
          value: 20
        }
      ],
      pageLimitSet: null,
      //
      tableList: [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      timelineData: [
        {
          color: 'primary',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls1',
          time: '25 Days Ago'
        },
        {
          color: 'warning',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls2',
          time: '15 Days Ago'
        },
        {
          color: 'success',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls3',
          time: '20 mins ago'
        },
        {
          color: 'primary',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls4',
          time: '25 Days Ago'
        },
        {
          color: 'warning',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls5',
          time: '15 Days Ago'
        },
        {
          color: 'success',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls6',
          time: '20 mins ago'
        }
      ],
      tableData: [],
      selected_data: null,
      //Ag Grid Table
      gridApi: {},
      gridOptions: {
        accentedSort: true
      },
      gridColumnApi: {},
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
        // autoHeight: true
      },
      columnApi: null,
      rowData: null,
      context: {},
      components: {
        ToggleActions,
        EditActions,
        DeleteActions,
        PreviewActions,
        StatusCell,
        CreatedAtCell,
        TagShow,
        DynamicDate,
        DynamicBoolean,
        DynamicSelect,
        CountryCell,
        RolesCell,
        PhoneImageCell,
        EmailAction,
        StudentsListAction,
        CoursesListAction,
        FullNameCell
      },
      staticDisplayField: [
        {
          field_label: 'First Name',
          field_name: 'first_name'
        },
        {
          field_label: 'Last Name',
          field_name: 'last_name'
        },
        {
          field_label: 'Address 1',
          field_name: 'address1'
        },
        {
          field_label: 'Address 2',
          field_name: 'address2'
        },
        {
          field_label: 'State',
          field_name: 'state'
        },
        {
          field_label: 'Country',
          field_name: 'platform_customer_countries_id'
        },
        {
          field_label: 'City',
          field_name: 'city'
        },
        {
          field_label: 'Zip',
          field_name: 'zip'
        }
      ],
      columnDefsBackup: [],
      columnDefs: [
        {
          headerName: '',
          field: 'isSelected',
          minWidth: 60,
          filter: true,
          checkboxSelection: true,
          // checkboxSelection: (params) => {
          //
          //   if (params.data.basic_details.active_user === '1') {

          //     return true
          //   } else {
          //     return false
          //   }
          // },
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: '#',
          field: 'row_index',
          sortable: false,
          minWidth: 60,
          filter: true,
          resizable: true,
          editable: false
        },
        {
          headerName: 'First Name',
          field: 'basic_details.first_name',
          minWidth: 150,
          filter: true,
          field_type: 'system',
          editable: params => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Last Name',
          field: 'basic_details.last_name',
          minWidth: 150,
          filter: true,
          field_type: 'system',
          editable: params => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
          // width: 150
        },
        {
          headerName: 'Email',
          field: 'basic_details.email.email',
          minWidth: 150,
          filter: true,
          field_type: 'system',
          editable: params => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
          // width: 150
        },
        {
          headerName: 'Phone',
          field: 'basic_details.phone.phone',
          minWidth: 150,
          filter: true,
          field_type: 'system',
          editable: params => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Role',
          // field: 'basic_details.roles[0].role_name',
          valueGetter: params => {
            return params.data.basic_details.roles[0].role_name
            // if (params.data.basic_details.user_type === 'Parent') {
            //   return 'Company Account'
            // } else {
            //   return 'Individual Company'
            // }
          },
          minWidth: 150,
          filter: true,
          editable: false
          // cellRendererFramework: 'StatusCell',
          // editable: (params) => {
          //   if (params.data.is_active === '1') {
          //     return true
          //   } else {
          //     return false
          //   }
          // }
        },
        {
          headerName: 'Tag',
          field: 'tags',
          minWidth: 150,
          filter: true,
          editable: false,
          cellRendererFramework: 'TagShow'
        },
        {
          headerName: 'Address 1',
          field: 'basic_details.address.address1',
          minWidth: 150,
          filter: true,
          editable: params => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Address 2',
          field: 'basic_details.address.address2',
          minWidth: 150,
          filter: true,
          editable: params => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'County/State',
          field: 'basic_details.address.state',
          minWidth: 150,
          editable: params => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          },
          filter: true
        },
        {
          headerName: 'Country',
          field: 'basic_details.address.country.country_name',
          minWidth: 150,
          editable: false,
          filter: true
        },
        {
          headerName: 'City',
          field: 'basic_details.address.city',
          minWidth: 150,
          filter: true,
          editable: params => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Postcode/Zip',
          field: 'basic_details.address.zip',
          minWidth: 150,
          filter: 'agNumberColumnFilter',
          editable: params => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.basic_details.active_user === '1') {
              return true
            } else {
              return false
            }
          }
        }
      ],
      /// bulk buttons
      isRowSelected: false,
      showCourseListModal: false,
      showStudentListModal: false,
      active_status_list: [],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1,
        limit: 10
      }
    }
  },
  watch: {
    columnRearrangementModal () {
      if (!this.columnRearrangementModal) {
        this.fetchingDynamicFieldAndFilter()
        this.fetchDisplayFields('Staff', this.$store.getters.customerId).then(
          () => {
            this.gridOptions.api.sizeColumnsToFit()
          }
        )
        this.searchByfilter()
        // this.gridOptions.api.refreshCells()
      }
    },
    tagSelected () {
      this.filterTagList(this.platform_module_id)
    },
    pageLimitSet () {
      this.handlePageChange(1)
    },
    get_leads_deleted_id () {
      if (this.get_leads_deleted_id) {
        const table = this.tableData
        const dlt_id = table.findIndex(
          item => item.basic_details.operation_user_id === this.get_leads_deleted_id
        )
        table.splice(dlt_id, 1)
        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.tableData = table

        if (this.tableData.length === 0 && !this.meta.next_page_url) {
          this.handlePageChange(this.meta.current_page - 1)
        } else {
          this.handlePageChange(this.meta.current_page)
        }
      }
    },
    get_leads_toggle_data: {
      deep: true,
      handler () {
        const table = this.tableData
        table.map(element => {
          if (
            element.basic_details.operation_user_id ===
            this.get_leads_toggle_data.row_details.basic_details
              .operation_user_id
          ) {
            element.basic_details.active_user = this.get_leads_toggle_data
              .toggle
              ? '1'
              : '0'
            element.actionData.toggle = this.get_leads_toggle_data.toggle
          }
        })
        this.tableData = table
      }
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi

    this.fetchingDynamicFieldAndFilter()

    // this.columnDefs.push({
    //   headerName: 'Preview',
    //   field: 'actionData',
    //   width: 110,
    //   editable: false,
    //   filter: false,
    //   cellRendererFramework: 'PreviewActions'
    // })
    // const actionField = {
    //   headerName: 'Active',
    //   field: 'actionData',
    //   editable: false,
    //   filter: false,
    //   cellRendererFramework: 'ToggleActions',
    //   width: 100

    // }
    // this.columnDefs.push(actionField)
    // if (this.checkEditPermission()) {
    //   this.columnDefs.push({
    //     headerName: 'Edit',
    //     field: 'actionData',
    //     width: 100,
    //     editable: false,
    //     filter: false,
    //     cellRendererFramework: 'EditActions'
    //   })
    // }
    // if (this.checkDeletePermission()) {
    //   this.columnDefs.push({
    //     headerName: 'Delete',
    //     field: 'actionData',
    //     width: 100,
    //     editable: false,
    //     filter: false,
    //     cellRendererFramework: 'DeleteActions'
    //   })
    // }

    //fetching dynamic fields and field and filer list

    this.fetchMainFilter('Staff', this.table_name)
    // this.fetch_table_filter_data()
    // this.fetchFieldAndFilterList('Staff')

    const queryParams = this.$route.query || {}
    this.query_page.page = queryParams.page || 1
    this.query_page.limit = queryParams.limit || 10
    // this.fetch_leads_active_status()

    this.gridApi = this.gridOptions.api
    // Object.assign(this.gridApi, this.isRowSelectable)
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        '.ag-header-container'
      )
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }
  },
  created () {
    this.fetchCountry()

    this.fetchingDynamicFieldAndFilter()
    this.fetch_field_list()
    this.fetchRoleList('system')
    this.fetchRoleList('custom')
    // if (data) {
    //   this.fetchRoleList('system')
    // }
    this.checkingQuery('/staff')
    //checking school admin ->set schooladmin to true
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
    // this.checkingQuery()
    this.fetchDisplayFields('Staff', this.$store.getters.customerId).then(
      () => {
        this.gridOptions.api.sizeColumnsToFit()
      }
    )

    //
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  methods: {
    async CoursePopupClose () {
      this.showCourseListModal = false
    },
    async StudentPopupClose () {
      this.showStudentListModal = false
    },
    async enrolledCourse (id) {
      this.user_id = id
      this.showCourseListModal = true
    },
    async enrolledStudent (id) {
      this.user_id = id
      this.showStudentListModal = true
    },
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        if (sortState.length === 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )

          this.sorting_obj.direction = sortState[0].sort

          this.sorting_obj.field_type = this.gridOptions.columnApi.getColumn(
            this.sorting_obj.attribute
          ) ? this.gridOptions.columnApi.getColumn(
              this.sorting_obj.attribute
            ).colDef.field_type : 'system'

          const payload = {
            search: this.search,
            customer_id: this.$store.getters.customerId,
            limit: this.pageLimitSet
          }
          this.$vs.loading({
            text: 'Loading...'
          })
          const { data } = await fetchUserBySearch(
            payload,
            this.meta,
            this.sorting_obj
          )
          const table = data.data.operationalUser
          this.meta = data.data.meta
          table.map((row, index) => {
            const actionData = {
              toggle: row.basic_details.active_user === 1,
              view: false
            }
            const row_index = index + 1
            const status_list = this.active_status_list
            Object.assign(row, { actionData })
            Object.assign(row, { row_index })
            Object.assign(row, { status_list })
          })
          this.tableData = table
          this.fetchTag(this.platform_module_id)
          this.gridOptions.api.refreshCells()
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.$vs.loading.close()
      }
    },
    resizeChanges: _.debounce(async function (e) {
      const all_columns = this.gridColumnApi
        .getAllDisplayedColumns()
        .map(column => column.getColId())
      console.log(e)

      const orders_info = []
      all_columns.forEach((value, key) => {
        orders_info.push({
          field_name: value,
          order: key
        })
      })
      const fields_display_order = []
      this.displayList.forEach((element, key) => {
        fields_display_order.push({
          fields_display_order_id: element.id,
          displayed: element.displayed,
          field_type: element.field_type,
          field_name: element.field_name,
          field_id: element.field_id,
          table_name:element.table_name,
          order: key,
          field_label: element.field_label,
          is_child: element.is_child,
          is_static: element.is_static,
          input_type: element.input_type,
          column_width:
            element.field_label === e.column.colDef.headerName
              ? e.column.actualWidth
              : element.column_width
        })
        // }
      })

      const payload = {
        fields_display_order,
        customer_id: this.$store.getters.customerId,
        from_list: '0',
        type: 'Staff',
        table_name:this.table_name
      }

      const allGridColumns = this.gridOptions.columnApi.getAllGridColumns()
      this.columnDefsBackup = allGridColumns.map(ele => {
        return ele.colDef
      })

      //Finally calling API to save column by providing the payload generated from the above codes and logic
      this.rearrangeColumn(payload)
    }, 1000),
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async vm => {
      try {
        const payload = {
          search: vm.search,
          customer_id: vm.$store.getters.customerId,
          limit: vm.pageLimitSet
        }

        const { data } = await fetchUserBySearch(
          payload,
          vm.meta,
          vm.sorting_obj
        )
        const table = data.data.operationalUser
        vm.meta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.basic_details.active_user === 1,
            view: false
          }
          const row_index = index + 1
          const status_list = vm.active_status_list
          Object.assign(row, { actionData })
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
        })
        vm.tableData = table

        // this.firstData = table
        vm.fetchTag(vm.platform_module_id)
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    checkIfRequiredField (params) {
      const { headerName } = params
      const requiredFields = [
        'First Name',
        'Last Name',
        'Email',
        'Phone',
        'Role Name'
      ]
      if (requiredFields.includes(headerName)) {
        return true
      } else {
        return false
      }
    },
    handleColumnHideShow (params) {
      const allowHide = this.checkIfRequiredField(params.column.colDef)
      if (allowHide) {
        this.columnDefs = []
        setTimeout(() => {
          this.gridOptions.api.setColumnDefs(this.columnDefsBackup)
          this.gridOptions.api.sizeColumnsToFit()
        }, 0)
      } else {
        this.handleRearrangement(params, true)
      }
    },
    handleRearrangement (param, fromHandleColumnHideShow) {

      //Taking all existing columns from ag-grid table showing now to get order and field name information
      const all_columns = this.gridColumnApi
        .getAllDisplayedColumns()
        .map(column => column.getColId())

      // Generating above columns orders (Column Index) and field_name object.
      // Here all the Ag-grid column received are already in arranged or sorted order by ag-grid itself after the rearrangement we do
      const orders_info = []
      all_columns.forEach((value, key) => {
        orders_info.push({
          field_name: value,
          order: key
        })
      })

      //Just providing a 100 milisecond for loop above to be completed before further process, it's quite important here
      setTimeout(() => {
        let column_rearranged = null
        //Taking currect rearranged column information by ag-grid 'columnMoved' event to give it a new order
        column_rearranged = this.displayList.filter(x => {
          return x.field_name === this.getCorrectFieldName(param.column.colId)
        })

        //Check if event fired is ag-grid columnVisible (fromHandleColumnHideShow)
        if (fromHandleColumnHideShow) {
          column_rearranged = this.displayList.filter(x => {
            return (
              x.field_name === this.getCorrectFieldName(param.column.colId)
            )
          })
        }

        // const old_order = column_rearranged[0].order
        // const new_order = param.toIndex - 1

        //Checking if currect rearranged column is inside the array of column to show given by backend then proceed else just skip
        if (column_rearranged.length) {

          column_rearranged[0].order =
            orders_info.filter(x => {
              return x.field_name === param.column.colId
            }).order - 1


          //Just delete old information since we need new order infor, we can also just change order property here,
          //I just removed and added again with new order information, both will work here
          this.displayList.splice(
            this.displayList.findIndex(
              x => x.field_name === this.getCorrectFieldName(param.column.colId)
            ),
            1
          )

          //Adding again the removed column above, with new order info
          this.displayList.unshift(column_rearranged[0])

          const fields_display_order = []
          this.displayList.forEach(element => {
            //If all currecnt ag-grid column is inside the array of column to show given by backend then proceed else just skip
            const found = orders_info.find(x => {
              return (
                x.field_name === element.field_name ||
                element.field_name === this.getCorrectFieldName(x.field_name)
              )
            })

            // If all the other column received from ag-grid is in array of column to show,
            //proceed and make a required payload for API call to save column re-arrangement information

            if (found) {
              //Adding new order returned by ag-grid for an element in a loop
              element.order = found.order - 1

              //Making required payload object form the API to save column re-arrangement
              //All the information is already in the is in array of column to show received from backend,
              //just found it and added it make payload object

              fields_display_order.push({
                fields_display_order_id: element.id,
                displayed: element.displayed,
                field_type: element.field_type,
                field_name: element.field_name,
                field_id: element.field_id,
                order: element.order,
                field_label: element.field_label,
                is_child: element.is_child,
                is_static: element.is_static,
                input_type: element.input_type
              })
            }
          })

          //Final payload object for re-arrangement API
          const payload = {
            fields_display_order,
            customer_id: this.$store.getters.customerId,
            from_list: '0',
            type: 'Staff',
            table_name:this.table_name
          }

          const allGridColumns = this.gridOptions.columnApi.getAllGridColumns()
          this.columnDefsBackup = allGridColumns.map(ele => {
            return ele.colDef
          })

          //Finally calling API to save column by providing the payload generated from the above codes and logic
          this.rearrangeColumn(payload)
        }
      }, 200)
    },
    async rearrangeColumn (payload) {
      try {
        await arrangeColumn(payload)
      } catch (e) {
        console.error(e)
      }
    },
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId === 'basic_details.company') {
        field_name = 'company'
      } else if (
        colId === 'basic_details.phone.phone' ||
        colId === 'basic_details.phone.phone_1'
      ) {
        field_name = 'phone'
      } else if (colId === 'tags_1') {
        field_name = 'tags'
      } else if (
        colId === 'basic_details.address.address1' ||
        colId === 'basic_details.address.address1_1'
      ) {
        field_name = 'address1'
      } else if (
        colId === 'basic_details.address.address2' ||
        colId === 'basic_details.address.address2_1'
      ) {
        field_name = 'address2'
      } else if (
        colId === 'basic_details.address.zip' ||
        colId === 'basic_details.address.zip.zip_1'
      ) {
        field_name = 'zip'
      } else if (
        colId === 'basic_details.address.city' ||
        colId === 'basic_details.address.city.city_1'
      ) {
        field_name = 'city'
      } else if (
        colId === 'basic_details.address.state' ||
        colId === 'basic_details.address.state_1'
      ) {
        field_name = 'state'
      } else if (
        colId === 'basic_details.email.email' ||
        colId === 'basic_details.email.email_1'
      ) {
        field_name = 'email'
      } else if (
        colId === 'basic_details.address.country.country_name' ||
        colId === 'basic_details.address.country.country_name_1'
      ) {
        field_name = 'platform_customer_countries_id'
      } else if (
        colId === 'basic_details.last_name' ||
        colId === 'basic_details.last_name_1'
      ) {
        field_name = 'last_name'
      } else if (
        colId === 'basic_details.first_name' ||
        colId === 'basic_details.first_name_1'
      ) {
        field_name = 'first_name'
      } else if (
        colId === 'basic_details.phone.mobile' ||
        colId === 'basic_details.phone.mobile_1'
      ) {
        field_name = 'mobile'
      } else if (colId === '0') {
        field_name = 'user_roles_id'
      } else if (colId === 'basic_details.roles[0].user_role_id') {
        field_name = 'user_role_id'
      } else if (
        colId === 'basic_details.created_at' ||
        colId === 'basic_details.created_at_1'
      ) {
        field_name = 'created_at'
      }
      return field_name
    },
    async exportApi () {
      const data = await exportApiDownload(
        this.$store.getters.customerId,
        'staff'
      )
      this.downloadItem(data.data.data.url, data.data.data.name)
    },
    downloadItem (url, label) {
      axios
        .get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'mime' })
          // const blob = new Blob([response.data], { type: 'application/pdf' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          // link.download = `${label}.${url.split('.')[url.split('.').length - 1]}`
          link.download = `${label}`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    closeRearrangementModal (value) {
      if (value) {
        this.columnRearrangementModal = false
      }
    },
    excelModal () {
      this.excelPopUp = true
    },
    uploadSuccess (success) {
      if (success) {
        this.excelPopUp = false
        this.searchByfilter()
      } else {
        this.searchByfilter()
      }
    },
    columnRearrangement () {
      this.columnRearrangementModal = true
      // document.body.classList.add('overflow-hidden')
    },

    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(38, customerId, {table_name:this.table_name})
        //

        this.staticFields = data.data.module_fields

        //
      } catch (e) {}
    },
    handleExport () {
      const customerId = this.$store.getters.customerId

      let exportURL = `${process.env.VUE_APP_API_URL}staff_csv_download?customer_id=${customerId}&`
      const BulkSelected = this.getSelectedRows()

      for (let i = 0; i < BulkSelected.length; i++) {
        if (parseInt(BulkSelected[i].basic_details.active_user) === 1) {
          if (typeof BulkSelected[i + 1] === 'undefined') {
            exportURL += `users_id[]=${BulkSelected[i].basic_details.operation_user_id}`
          } else {
            exportURL += `users_id[]=${BulkSelected[i].basic_details.operation_user_id}&`
          }
        }
      }
      //window.open(exportURL, '_tab')
      this.openInNewTab(exportURL)
    },
    openInNewTab (href) {
      Object.assign(document.createElement('a'), {
        target: '_blank',
        href
      }).click()
    },
    ...mapActions([
      'SET_DELETE_ID',
      'SET_VIEW_LEADS_SIDEBAR',
      'SET_VIEW_LEADS_SIDEBAR_DATA',
      'SET_LEADS_ACTIVE_STATUS'
    ]),
    resetSearch () {
      this.select_filter_id = null
      this.tagSelected = []
      this.searchByRoleType = ''
      this.search = ''
      this.handlePageChange(1)
    },
    searchByfilter () {
      const tags = this.tagSelected.map(element => {
        return element.id
      })

      const payload = {
        role_id: this.searchByRoleType,
        tag_ids: tags
      }

      this.fetch_list(payload)
    },
    async fetchRoleList (type) {
      try {
        const paramspayload = {
          type
        }
        const res = await role_list(
          this.$store.getters.customerId,
          paramspayload
        )
        if (res) {
          // this.roleList = [...this.roleList, ...res.data.data.role_list]
          this.roleList.push(...res.data.data.role_list)
        }

        //     return true
        // this.fetchRoleList('system')
      } catch (error) {
        console.log(error)
      }
    },
    async checkingQuery () {
      if (
        this.$route.query &&
        'page' in this.$route.query &&
        !isNaN(this.$route.query.page)
      ) {
        this.meta.current_page = this.$route.query.page
      } else {
        const queryPayload = Object.assign({}, this.$route.query)
        queryPayload.page = 1
        this.$router
          .replace({ path: '/staff', query: queryPayload })
          .catch(() => {})
      }
    },
    fetchingDynamicFieldAndFilter () {
      const customField = this.fetch_customfields_list('Staff')
      customField.then(responseData => {
        if (responseData) {
          this.fetchFieldAndFilterList('Staff', this.table_name) //this is fetching dynamic field and static field for filter modules
        }
      })
    },
    bulkMailAdd () {
      // const BulkSelected = this.getSelectedRows()
      // const mail_ids = []
      // for (let i = 0; i < BulkSelected.length; i++) {
      //   if (BulkSelected[i].basic_details.active_user === 1) {
      //     mail_ids.push(BulkSelected[i].basic_details.email.email)
      //     this.user_ids.push(BulkSelected[i].basic_details.operation_user_id)

      //   }
      // }
      const BulkSelected = this.getSelectedRows()
      const mail_ids = BulkSelected.filter(ele => {
        return ele.basic_details.active_user === 1
      }).map(ele => {
        return ele.basic_details.email.email
      })

      this.selected_lead_is = BulkSelected.map(ele => {
        return ele.basic_details.operation_user_id
      })

      this.mail_id = mail_ids
    },
    async mail_body (mail_details) {
      const payload = {
        staff_ids: this.selected_lead_is,
        header: mail_details[1],
        body: mail_details[2],
        customer_id: this.$store.getters.customerId
      }
      const { data } = await bulkEmailApi(payload)
      this.bulkEmailModal = false
      this.$vs.notify({
        title: 'Success',
        text: 'Email sent Successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    async bulkupdatelist (updated_details) {
      try {
        const BulkSelected = this.getSelectedRows()

        const updated_ids = []
        for (let i = 0; i < BulkSelected.length; i++) {
          if (BulkSelected[i].basic_details.active_user === 1) {
            updated_ids.push(BulkSelected[i].basic_details.operation_user_id)
          }
          // }
        }

        if (updated_ids.length === 0) {
          this.$vs.notify({
            title: 'Warning',
            text: 'Selected rows are non-actionable',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        } else {
          const payload = {
            staff_ids: updated_ids,
            customer_id: this.$store.getters.customerId,
            field_name: updated_details[0],
            value: updated_details[1]
          }
          bulkUpdateApi(payload).then(data => {
            if (
              updated_details[0] === 'first_name' ||
              updated_details[0] === 'last_name' ||
              updated_details[0] === 'middle_name'
            ) {
              const newRowData = this.tableData.map(row => {
                if (updated_ids.includes(row.basic_details.operation_user_id)) {
                  row.basic_details[updated_details[0]] = data.data.data.value
                }
                return row
              })
              this.tableData = newRowData
            } else if (
              updated_details[0] === 'platform_customer_countries_id'
            ) {
              const newRowData = this.tableData.map(row => {
                if (updated_ids.includes(row.basic_details.operation_user_id)) {
                  row.basic_details.address[updated_details[0]] =
                    data.data.data.value
                  this.countryList.forEach(country => {
                    if (data.data.data.value === country.id) {
                      row.basic_details.address.country.id =
                        data.data.data.value
                      row.basic_details.address.country.country_name =
                        country.country_name
                    }
                  })
                }
                return row
              })
              this.tableData = newRowData
            } else if (
              ['address1', 'address2', 'city', 'zip', 'state'].includes(
                updated_details[0]
              )
            ) {
              const newRowData = this.tableData.map(row => {
                if (updated_ids.includes(row.basic_details.operation_user_id)) {
                  row.basic_details.address[updated_details[0]] =
                    data.data.data.value
                }
                return row
              })
              this.tableData = newRowData
            } else if (['user_roles_id'].includes(updated_details[0])) {
              const newRowData = this.tableData.map(row => {
                if (updated_ids.includes(row.basic_details.operation_user_id)) {
                  row.basic_details.roles[0].user_role_id =
                    data.data.data.value
                }
                return row
              })
              this.tableData = newRowData
            } else {
              const newRowData = this.tableData.map(row => {
                if (updated_ids.includes(row.basic_details.operation_user_id)) {
                  row[updated_details[0]] = data.data.data.value
                }
                return row
              })
              this.tableData = newRowData
            }
          })
          this.bulkupdateModal = false
        }
      } catch (e) {}
    },
    async fetchDisplayFields (moduleName, customerId) {
      //
      try {
        const payload = {
          customer_id: customerId,
          fetch_status: 'display',
          type: 'Staff',
          table_name:this.table_name
        }
        const { data } = await fetchField(payload)
        const displayList = data.data.results
        this.displayList = data.data.results
        let displayColomns = []
        if (displayList.length === 0) {
          displayColomns = this.staticField
          this.displayListofdata = this.staticDisplayField
        } else {
          this.displayListofdata = displayList
          for (const item of displayList) {
            if (item.field_type === 'dynamic') {
              if (item.inputtype === 'datetime') {
                const _tempObj = {
                  headerName: item.field_label,
                  field: item.field_name,
                  table_name: item.table_name,
                  filter: false,
                  sortable: true,
                  minWidth: item.column_width,
                  cellRendererFramework: 'DynamicDate',
                  CellRendererParams: item.field_name,
                  field_type: 'dynamic',
                  editable: (params) => {
                    if (!this.checkEditPermission()) {
                      return false
                    }
                    if (params.data.basic_details.active_user === 1) {
                      return true
                    } else {
                      return false
                    }
                  }
                }
                displayColomns.push(_tempObj)
              } else if (item.input_type === 'boolean') {
                const _tempObj = {
                  headerName: item.field_label,
                  field: item.field_name,
                  table_name: item.table_name,
                  filter: false,
                  minWidth: item.column_width,
                  cellRendererFramework: 'DynamicBoolean',
                  CellRendererParams: item.field_name,
                  editable: (params) => {
                    if (!this.checkEditPermission()) {
                      return false
                    }
                    if (params.data.basic_details.active_user === 1) {
                      return true
                    } else {
                      return false
                    }
                  },
                  sortable: true,
                  field_type: item.field_type,
                  filterParams: { update_user: this.update_user }
                }
                displayColomns.push(_tempObj)
              } else if (item.input_type === 'select') {
                const _tempObj = {
                  headerName: item.field_label,
                  field: item.field_name,
                  filter: false,
                  table_name: item.table_name,
                  minWidth: item.column_width,
                  cellRendererFramework: 'DynamicSelect',
                  sortable: true,
                  field_type: item.field_type,
                  CellRendererParams: {
                    item_name: item.field_name,
                    custom_fields: this.custom_fields.filter(ele => {
                      if (ele.input_type === 'select') {
                        return ele
                      }
                    })
                  },
                  editable: (params) => {
                    if (!this.checkEditPermission()) {
                      return false
                    }
                    if (params.data.basic_details.active_user === 1) {
                      return true
                    } else {
                      return false
                    }
                  },
                  filterParams: { update_user: this.update_user }
                }
                displayColomns.push(_tempObj)
              } else if (
                item.input_type !== 'datetime' &&
                item.input_type !== 'boolean' &&
                item.input_type !== 'select'
              ) {
                const _tempObj = {
                  input_type: item.input_type,
                  headerName: item.field_label,
                  field: item.field_name,
                  table_name: item.table_name,
                  filter: false,
                  sortable: true,
                  minWidth: item.column_width,
                  field_type: 'dynamic',
                  editable: (params) => {
                    if (
                      item.input_type !== 'checkbox' &&
                      item.input_type !== 'multiselect' &&
                      item.input_type !== 'radio'
                    ) {
                      if (!this.checkEditPermission()) {
                        return false
                      }
                      if (params.data.basic_details.active_user === 1) {
                        return true
                      } else {
                        return false
                      }
                    } else {
                      return false
                    }
                  }
                }
                displayColomns.push(_tempObj)
              }
            } else if (item.field_name.includes('phone')) {
              const _tempObj = {
                headerName: item.field_label,
                field: `basic_details.phone.${item.field_name}`,
                filter: false,
                sortable: true,
                table_name: item.table_name,
                field_type: item.field_type,
                minWidth: item.column_width,
                cellRendererFramework: 'PhoneImageCell',
                editable: (params) => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user === 1) {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (item.field_name.includes('email')) {
              const _tempObj = {
                headerName: item.field_label,
                field: `basic_details.email.${item.field_name}`,
                filter: false,
                table_name: item.table_name,
                sortable: true,
                field_type: item.field_type,
                minWidth: item.column_width,
                editable: params => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user === 1) {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (
              ['address1', 'zip', 'state', 'address2', 'city'].includes(
                item.field_name
              )
            ) {
              const _tempObj = {
                headerName: item.field_label,
                field: `basic_details.address.${item.field_name}`,
                filter: false,
                sortable: true,
                table_name: item.table_name,
                field_type: item.field_type,
                minWidth: item.column_width,
                editable: params => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user === 1) {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (
              ['platform_customer_countries_id'].includes(item.field_name)
            ) {
              const _tempObj = {
                headerName: item.field_label,
                field: 'basic_details.address.country.country_name',
                filter: false,
                sortable: true,
                table_name: item.table_name,
                field_type: item.field_type,
                minWidth: item.column_width,
                cellRendererFramework: 'CountryCell',
                filterParams: {
                  country: this.countryList,
                  update_user: this.update_user
                },
                editable: (params) => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user === 1) {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (['user_roles_id'].includes(item.field_name)) {
              const _tempObj = {
                headerName: item.field_label,
                field: 'basic_details.roles[0].user_role_id',
                filter: false,
                sortable: true,
                table_name: item.table_name,
                field_type: item.field_type,
                minWidth: item.column_width,
                cellRendererFramework: 'RolesCell',
                filterParams: {
                  roleList: this.roleList,
                  update_user: this.update_user
                },
                editable: (params) => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user === 1) {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (['created_at'].includes(item.field_name)) {
              const _tempObj = {
                headerName: item.field_label,
                field: 'basic_details.created_at',
                table_name: item.table_name,
                filter: false,
                sortable: true,
                field_type: item.field_type,
                minWidth: item.column_width,
                cellRendererFramework: 'CreatedAtCell'
              }
              displayColomns.push(_tempObj)
            } else if (['user_roles_id'].includes(item.field_name)) {
              const _tempObj = {
                headerName: item.field_label,
                valueGetter: params => {
                  return params.data.basic_details.roles[0].role_name
                },
                filter: false,
                table_name: item.table_name,
                sortable: true,
                field_type: item.field_type,
                minWidth: 150,
                editable: params => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user === 1) {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (item.field_label === 'First Name') {
              const _tempObj = {
                headerName: 'Full Name',
                field: `basic_details.${item.field_name}`,
                filter: false,
                sortable: true,
                table_name: item.table_name,
                field_type: 'system',
                minWidth: item.column_width,
                cellRendererFramework: 'FullNameCell',
                suppressMovable: false,
                editable: params => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user === 1) {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else {
              const _tempObj = {
                headerName: item.field_label,
                field: item.field_name,
                filter: false,
                sortable: true,
                table_name: item.table_name,
                field_type: item.field_type,
                minWidth: 150,
                editable: params => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user === 1) {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            }
          }
          const staticField1 = {
            headerName: '',
            minWidth: 60,
            field: 'isSelected',
            filter: false,
            sortable: false,
            checkboxSelection: params => {
              return true
              /* if (params.data.is_active === '1') {
                return true
              } else {
                return false
              } */
            },
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true
          }
          const staticField2 = {
            headerName: '#',
            field: 'row_index',
            sortable: false,
            filter: false,
            minWidth: 60,
            editable: false,
            valueGetter:(params) => {
              return ((this.meta.limit * (this.meta.current_page - 1)) + params.node.rowIndex + 1)
            }
          }
          displayColomns.unshift(staticField2)
          displayColomns.unshift(staticField1)
        }

        const tags = {
          headerName: 'Tags',
          field: 'tags',
          sortable: true,
          field_type: 'system',
          editable: false,
          cellRendererFramework: 'TagShow',
          minWidth: 150
        }
        displayColomns.push(tags)

        const actionField5 = {
          headerName: 'Courses',
          field: 'course_count',
          minWidth: 110,
          maxWidth: 110,
          editable: false,
          sortable: true,
          field_type: 'system',
          filter: false,
          cellStyle: { color: 'blue' },
          onCellClicked: (params) => this.enrolledCourse(params.data.basic_details.operation_user_id)
        }
        displayColomns.push(actionField5)

        const actionField6 = {
          headerName: 'Students',
          field: 'student_count',
          minWidth: 110,
          maxWidth: 110,
          editable: false,
          filter: false,
          sortable: true,
          field_type: 'system',
          cellStyle: { color: 'blue' },
          onCellClicked: (params) => this.enrolledStudent(params.data.basic_details.operation_user_id)
        }
        displayColomns.push(actionField6)

        const actionField = {
          headerName: 'Active',
          field: 'actionData',
          editable: false,
          sortable: false,
          filter: false,
          cellRendererFramework: 'ToggleActions',
          minWidth: 90,
          maxWidth: 90
          // cellRendererFramework: 'CellRendererActions'
        }
        displayColomns.push(actionField)

        if (this.checkEditPermission()) {
          const actionField1 = {
            headerName: 'Actions',
            field: 'actionData',
            minWidth: 100,
            sortable: false,
            maxWidth: 100,
            editable: false,
            filter: false,
            // cellRendererFramework: "EditActions",
            cellRendererFramework: 'CellRendererActions',
            CellRendererParams:{
              checkDeletePermission:this.checkDeletePermission(),
              checkEditPermission:this.checkEditPermission()
            }
          }
          displayColomns.push(actionField1)
        }

        this.columnDefs = displayColomns
        this.columnDefsBackup = displayColomns
        // this.columnDefs.push({headerName: 'New Column'})

        this.gridOptions.api.setColumnDefs(displayColomns)
        this.gridOptions.api.refreshCells({ force: true })
      } catch (e) {
        console.warn(e)
      }
    },
    addStaff () {
      this.addSideBar = true
      document.body.classList.add('overflow-hidden')
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {
        console.log(e)
      }
    },
    addNewFilter () {
      this.dynamicfilters.push({
        filterid: '',
        filtercondition: '',
        inputfieldvalue: ''
      })
    },
    delterFilter (counter) {
      this.dynamicfilters.splice(counter, 1)
    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      //
      return selectedData
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    handleBulkDelete () {
      const BulkSelected = this.getSelectedRows()
      const deleting_ids = []
      for (let i = 0; i < BulkSelected.length; i++) {
        if (BulkSelected[i].basic_details.active_user === 0) {
          deleting_ids.push(BulkSelected[i].basic_details.operation_user_id)
        }
        // }
      }

      if (deleting_ids.length === 0) {
        this.$vs.notify({
          title: 'Warning',
          text:
            'Can\'t remove an active staff. Please deactivate the staff first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } else {
        const payload = {
          deleteField: deleting_ids
        }

        delete_users(payload, this.$store.getters.customerId)
          .then(data => {
            const table = this.tableData
            for (const delete_id_itr of deleting_ids) {
              for (let i = 0; i < table.length; i++) {
                if (
                  delete_id_itr === table[i].basic_details.operation_user_id
                ) {
                  table.splice(i, 1)
                  // break
                }
              }
            }
            table.map((row, index) => {
              row.row_index = index + 1
            })
            this.isRowSelected = false
            this.tableData = table

            if (this.tableData.length === 0 && !this.meta.next_page_url) {
              this.handlePageChange(this.meta.current_page - 1)
            } else {
              this.handlePageChange(this.meta.current_page)
            }

            this.$vs.notify({
              title: 'Success',
              text: 'Bulk Deletion Successfull',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e)
          })
      }

      // bul
      // for( let )
    },
    showDetails (data) {
      this.viewSideBar = true
      this.selected_data = data
    },

    async fetch_list (payload, params = null) {
      // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const userId = this.$store.state.LoginStorage.user_details.customer_id
      try {
        const text = params
          ? 'Fetching Filter Staffs List ...'
          : 'Fetching Staff Lists...'
        this.$vs.loading({
          text
        })
        const { data } = await user_list(
          payload,
          userId,
          this.meta.current_page,
          params,
          this.pageLimitSet
        )

        const table = data.data.operationalUser
        this.meta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.basic_details.active_user === 1,
            view: false
          }
          const row_index = index + 1
          const status_list = this.active_status_list
          Object.assign(row, { actionData })
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
        })
        this.tableData = table

        // this.firstData = table
        this.fetchTag(this.platform_module_id)
      } catch (e) {
      } finally {
        this.$vs.loading.close()
      }
    },
    // filter methods
    get_table_id (id, table) {
      //id => number, table => array ... matching.
      for (let i = 0; i > table.length; i++) {
        if (table[i].basic_details.operation_user_id === id) {
          return i
        }
      }
    },
    handleDelete (tableList) {
      if (tableList.isActionable) {
        const table = this.tableData
        const rowId = tableList.basic_details.operation_user_id
        let deleted_index = null

        for (let i = 0; i < table.length; i++) {
          if (rowId === table[i].basic_details.operation_user_id) {
            deleted_index = i
            break
          }
        }
        table.splice(1, deleted_index)
        this.tableData = table
        this.$vs.notify({
          title: 'Success',
          text: 'Staff Deletion Successfull',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Cant Delete Staff, Turn on Action Button',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    //updated at 7:52 by yasin
    onCellValueChanged (params) {
      const data = []
      //data.colId = params.column.getId()
      data.user_id = params.data.basic_details.operation_user_id
      data.colId = params.colDef.field
      data.field_type = params.colDef.field_type === 'dynamic'
      if (data.colId === 'basic_details.first_name') {
        data.fieldvalue = params.data.basic_details.first_name
        data.colId = 'first_name'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Name field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      } else if (data.colId === 'basic_details.last_name') {
        data.fieldvalue = params.data.basic_details.last_name
        data.colId = 'last_name'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Name field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      } else if (data.colId === 'basic_details.email.email') {
        data.fieldvalue = params.data.basic_details.email.email
        data.colId = 'email'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Email field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      } else if (data.colId === 'basic_details.phone.phone') {
        // const phoneno = /^\d{10}$/
        const phoneno = /^\d+$/

        data.fieldvalue = params.data.basic_details.phone.phone
        data.colId = 'phone'
        if (data.fieldvalue.match(phoneno)) {
          data.fieldvalue = params.data.basic_details.phone.phone
        } else {
          this.$vs.notify({
            title: 'Warning',
            text: 'Phone field must be numeric',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      } else if (data.colId === 'basic_details.address.address1') {
        data.fieldvalue = params.data.basic_details.address.address1
        data.colId = 'address1'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Address field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      } else if (data.colId === 'basic_details.address.address2') {
        data.fieldvalue = params.data.basic_details.address.address2
        data.colId = 'address2'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Address field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      } else if (data.colId === 'basic_details.address.state') {
        data.fieldvalue = params.data.basic_details.address.state
        data.colId = 'state'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Address field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      } else if (data.colId === 'basic_details.address.city') {
        data.fieldvalue = params.data.basic_details.address.city
        data.colId = 'city'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Address field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      } else if (data.colId === 'basic_details.address.zip') {
        data.fieldvalue = params.data.basic_details.address.zip
        data.colId = 'zip'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Address field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      } else if (params.colDef.input_type === 'number') {
        const numdynamic = /^\d+$/
        data.fieldvalue = params.data[data.colId]

        if (data.fieldvalue.match(numdynamic)) {
          data.fieldvalue = params.data[data.colId]
        } else {
          this.showSuccessMessage(
            'Error',
            'This field Cant be string',
            'warning'
          )
          this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
          return false
        }
      } else {
        data.fieldvalue = params.data[data.colId]
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'This field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      }
      //
      this.update_user(data)
    },
    async update_user (data) {
      let payload = {
        updateField: {}
      }
      const user_id = data.user_id
      if (data) {
        if (data.field_type) {
          payload = {
            dynamic_fields: {
              [data.colId]: data.fieldvalue
            }
          }
        } else {
          payload = {
            updateField: {
              [data.colId]: data.fieldvalue
            }
          }
        }
      }

      try {
        const customerId = this.$store.getters.customerId

        const { data } = await update_user(user_id, payload, customerId)
        this.$vs.notify({
          title: 'Success',
          text: 'Staff Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (api_error) {
        this.$vs.notify({
          title: 'Warning',
          text: api_error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      }
    },

    handleViewSidebar () {
      const viewleads = false
      this.SET_VIEW_LEADS_SIDEBAR(viewleads)
      this.SET_VIEW_LEADS_SIDEBAR_DATA(null)
    },
    handlcreateSidebar (addedObject) {
      if (addedObject === false) {
        this.addSideBar = false
        document.body.classList.remove('overflow-hidden')
        this.$validator.errors.clear('Add_user')
      } else {
        if (addedObject.saveType === 'SaveAndClose') {
          this.addSideBar = false
        }
        document.body.classList.remove('overflow-hidden')
        this.$validator.errors.clear('Add_user')
        this.addNewUser(addedObject)
      }
      /*  this.addSideBar = false
      document.body.classList.remove('overflow-hidden')
      this.$validator.errors.clear('Add_user') */
    },
    addNewUser (added) {
      const actionData = {
        toggle: true,
        view: false
      }
      const status_list = this.active_status_list
      Object.assign(added, { status_list })
      Object.assign(added, { actionData })
      Object.assign(added, { isSelected: null })
      const addedarray = [added]
      this.tableData = [...addedarray, ...this.tableData]
      const table = this.tableData

      table.map((row, index) => {
        row.row_index = index + 1
      })
      this.tableData = table
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      if (selectedNodes) {
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map(node => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    handlePageChange (page) {
      if (!this.pageLimitSet) return

      const tags = this.tagSelected.map(element => {
        return element.id
      })
      const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = this.pageLimitSet
      queryPayload.role_id = this.searchByRoleType
      queryPayload.tag_ids = tags
      // this.meta.current_page = page
      const pageScroll = document.documentElement.scrollTop
      this.$router
        .replace({ path: '/staff', query: queryPayload })
        .catch(() => {})
        .then(() => {
          document.documentElement.scrollTop = pageScroll
        })
      if (this.select_filter_id) {

        const params = {
          filter_id: this.select_filter_id
        }

        this.fetch_list(queryPayload, params)
      } else if (this.search !== '' || this.sorting_obj.attribute !== '') {
        this.searchFunPage()
      } else {
        this.fetch_list(queryPayload)
      }

    },
    async searchFunPage () {
      try {
        const payload = {
          search: this.search,
          customer_id: this.$store.getters.customerId,
          limit: this.pageLimitSet
        }

        this.$vs.loading({
          text: 'Loading...'
        })

        const { data } = await fetchUserBySearch(
          payload,
          this.meta,
          this.sorting_obj
        )
        const table = data.data.operationalUser
        this.meta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.basic_details.active_user === 1,
            view: false
          }
          const row_index = index + 1
          const status_list = this.active_status_list
          Object.assign(row, { actionData })
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
        })
        this.tableData = table
        this.fetchTag(this.platform_module_id)
      } catch (e) {} finally {
        this.$vs.loading.close()
      }

    },
    cellSingleClicked (params) {
      //

      if (params.column.colDef.field === 'basic_details.first_name') {
        router.push({
          name: 'user-profile',
          params: { teacher_id: params.data.basic_details.operation_user_id }
        })
      }
    },

    getFilterByUser () {
      const query = {
        page: 1,
        limit: this.pageLimitSet,
        customerId: this.$store.getters.customerId
      }

      if (!this.select_filter_id) {
        this.fetch_list(query)
      } else {
        const params = {
          filter_id: this.select_filter_id
        }

        this.fetch_list(query, params)
      }

      //
    },
    overallSearch () {
      this.overallSearchHolder = !this.overallSearchHolder
    }
  },
  computed: {
    ...mapGetters([
      'get_leads_deleted_id',
      'get_leads_sidebar_view',
      'get_leads_sidebar_data',
      'get_leads_toggle_data'
    ]),
    isRowSelectable (rowNode) {
      return rowNode.data.is_active === '1'
    },
    limitedTableList () {
      //
      /* let tableList = []
      if (this.pageLimitSet === 'all') {
        tableList = this.tableData
      } else {
        const TableLength = this.tableData.length
        if (this.pageLimitSet >= TableLength) {
          tableList = this.tableData
        } else {
          for (let i = 0; i < this.pageLimitSet; i++) {
            tableList.push(this.tableData[i])
          }
        }
      } */
      // const tableList = this.tableData.splice(0, this.pageLimitSet)
      return this.tableData
    },
    slectMulti () {
      const selectedNodes = this.gridApi
      if (selectedNodes) {
        return this.gridApi.getSelectedNodes
      }
      // return selectedNodes
    }
    // isRowSelected () {
    //   // const selectedNodes = this.gridApi.getSelectedNodes()

    // }
  },
  beforeRouteLeave (to, from, next) {
    this.addSideBar = false
    this.filterSidebarBoolean = false
    const viewleads = false
    this.SET_VIEW_LEADS_SIDEBAR(viewleads)
    this.SET_VIEW_LEADS_SIDEBAR_DATA(null)
    setTimeout(() => {
      next()
    }, 0)
  }
}
</script>
<style>
.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /*height: auto !important;*/
  /*position: absolute;*/
  /*top: 12%;*/
}
/* [dir] .vs-content-sidebar.items-no-padding .vs-sidebar--items {
  overflow-y: scroll;
} */

.flatpickr-calendar.open {
  z-index: 111111111111115 !important;
}

.vs-notifications {
  z-index: 1111111111111151111 !important;
}

.gb-vue-timeline-update__title {
  font-size: 14px !important;
  margin-left: -12px !important;
}

.gb-vue-timeline-update__ago {
  margin-right: -9%;
}
.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  box-shadow: 7px 3px 15px #c7c6c6;
}
/* .ag-header-cell {
    padding: 2px !important;
  } */
@media (min-width: 1281px) and (max-width: 1919px) {
  .main-vertical .vx-navbar-wrapper {
    width: calc(100% - 260px);
  }
}
@media (min-width: 1920px) {
  .main-vertical .vx-navbar-wrapper {
    width: 88%;
  }
  /* .ag-grid-table {
    max-height: 350px;
  } */
  .v-nav-menu .vs-sidebar {
    max-width: 12%;
  }
  #content-area.content-area-reduced {
    margin-left: 12%;
  }
  .btn-w-icon i {
    font-size: 25px;
  }
}
</style>
<style scoped>
.custom-btn1 {
  padding: 5px 10px !important;
  font-size: 12px;
  border-radius: 0px;
  font-weight: 600;
}
.ag-pivot-off .ag-header-group-cell {
  /* font-size: 50px; */
  color: red;
}
.ag-grid-table {
  min-height: 250px;
}

li {
  list-style: none;
}

#selectdynamic {
  width: 100%;
  height: 38px;
  border-radius: 4px;
}
#dynamicradio {
  margin-right: 10px;
}

.select_custom {
  height: 40px;
  border: none;
  background-color: white;
  border: 1px solid #cccccc;
  color: #787878;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
}
</style>
